import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from './svgs/static_price_icon.svg'

export const StaticPriceIcon: React.VFC<SvgIconProps> = props => <SvgIcon component={Icon} sx={{ width: 35 }} {...props} />
